function Game({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 4H28V0H8V4H4C1.8 4 0 5.8 0 8V10C0 15.1 3.84 19.26 8.78 19.88C10.04 22.88 12.74 25.14 16 25.8V32H8V36H28V32H20V25.8C23.26 25.14 25.96 22.88 27.22 19.88C32.16 19.26 36 15.1 36 10V8C36 5.8 34.2 4 32 4ZM4 10V8H8V15.64C5.68 14.8 4 12.6 4 10ZM18 22C14.7 22 12 19.3 12 16V4H24V16C24 19.3 21.3 22 18 22ZM32 10C32 12.6 30.32 14.8 28 15.64V8H32V10Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Game;
